export default "__VITE_ASSET__B8RrvrB3__"